import Box from "@mui/material/Box";
import Button from "@mui/material/Button"; // MUI ICON COMPONENTS

import SalifyFallback from "src/lib/components/salify-fallback/default";
import { FlexBox } from "../../salify-next-layout/default/components/flex-box"; // ==============================================================
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";

// ==============================================================
const AddToCartButtons = ({ onBuyNow, onAddToCart, isDisabledActions }) => {
  return (
    <>
      {/* DESKTOP */}
      <Box display={{ xs: "none", md: "block" }}>
        <FlexBox flexDirection="column" gap="15px">
          <Button
            color="primary"
            variant="contained"
            disabled={isDisabledActions}
            onClick={onBuyNow}
            sx={{
              borderRadius: 2,
            }}
          >
            <SalifyFallback.Label path="Buy Now" default="Mua ngay" />
          </Button>
          <Button
            color="primary"
            variant="outlined"
            disabled={isDisabledActions}
            onClick={onAddToCart}
            sx={{
              borderRadius: 2,
            }}
          >
            <SalifyFallback.Label path="Add To Cart" default="Thêm vào Giỏ hàng" />
          </Button>
        </FlexBox>
      </Box>

      {/* MOBILE */}
      <Box flex="auto" display={{ xs: "block", md: "none" }}>
        <FlexBox flexDirection="row" gap="6px">
          <Button
            color="primary"
            variant="contained"
            disabled={isDisabledActions}
            onClick={onBuyNow}
            sx={{
              flex: "auto",
              borderRadius: 2,
            }}
          >
            <SalifyFallback.Label path="Buy Now" default="Mua ngay" />
          </Button>
          <Button
            variant="outlined"
            disabled={isDisabledActions}
            onClick={onAddToCart}
            sx={{
              width: 36,
              height: 36,
              color: "dark.dark0",
              borderColor: "light.light0",
              borderRadius: 2,
            }}
          >
            <AddShoppingCartIcon fontSize="small" />
          </Button>
        </FlexBox>
      </Box>
    </>
  );
};

export default AddToCartButtons;
